// Textos de Noticias (TKT-2220). Los literales siguen al Figma, incluida su ortografía ("imágen").
export default {
  cancel: 'Cancelar',
  close: 'Cerrar',
  save: 'Guardar',
  saveChanges: 'Guardar Cambios',
  delete: 'Eliminar',
  deleteNotice: 'Eliminar noticia',
  editNotice: 'Editar noticia',
  newTitle: 'Nuevo Mensaje',
  newTitleMobile: 'Nueva Noticia',
  editTitle: 'Editar Noticia',
  newBadge: '¡Nueva Noticia!',
  titleLabel: 'Título:',
  titleMobile: 'Título',
  descriptionLabel: 'Descripción:',
  descriptionMobile: 'Descripción',
  attachPreview: 'Adjuntar una imágen de vista previa:',
  attachArticle: 'Adjuntar una imágen al artículo:',
  attachPhoto: 'Adjuntar foto',
  attachPhotoMobile: 'Adjuntar Foto',
  removeFile: 'Quitar archivo',
  scheduleDuration: 'Agendar cuánto durará la noticia:',
  contentPlaceholder: 'Empieza a escribir aquí...',
  publishTo: 'Publicar noticia a:',
  publishAll: 'Publicar a todos',
  publishCustom: 'Publicar por Rol/Ubicación',
  chooseRoles: 'Elige los roles',
  chooseLocations: 'Elige las ubicaciones',
  roles: 'Roles',
  locations: 'Ubicación',
  allRoles: 'Todos los roles',
  allLocations: 'Todas las ubicaciones',
  searchLocations: 'Buscar ubicación',
  noResults: 'Sin resultados',
  loadMore: 'Cargar más',
  removeChip: 'Quitar {name}',
  publish: 'Publicar Noticia',
  schedule: 'Programar Noticia',
  confirmDeleteTitle: '¿Deseas eliminar esta noticia?',
  confirmDeleteBody: 'Una vez eliminada, no se podrá recuperar esta noticia.',
  confirmSaveTitle: '¿Deseas guardar cambios en esta noticia?',
  confirmSaveBody: 'Una vez guardados los cambios, no se podrán deshacer.',
  publishedBy: 'Publicado por {name}',
  fieldsRequired: 'Por favor rellena todos los campos obligatorios',
  audienceRequired: 'Elige al menos un rol o una ubicación, o publica a todos.',
  created: 'Noticia creada',
  scheduled: 'Noticia programada',
  updated: 'Noticia actualizada',
  deleted: 'Noticia eliminada',
  createError: 'Error al crear la noticia',
  scheduleError: 'Error al programar la noticia',
  updateError: 'Error al guardar los cambios',
  deleteError: 'Error al eliminar la noticia',
  loadError: 'No se pudo cargar la noticia',
  editor: {
    toolbar: 'Herramientas de formato',
    style: 'Estilo de texto',
    font: 'Tipografía',
    color: 'Color',
    bold: 'Negrita',
    italic: 'Cursiva',
    underline: 'Subrayado',
    strike: 'Tachado',
    alignLeft: 'Alinear a la izquierda',
    alignCenter: 'Centrar',
    alignRight: 'Alinear a la derecha',
    orderedList: 'Lista numerada',
    bulletList: 'Lista con viñetas',
    link: 'Insertar liga',
    linkHint: 'Escribe la dirección del sitio (https://...).',
    insert: 'Insertar',
    image: 'Insertar imagen',
    imageTooBig: 'La imagen no debe pesar más de 5 MB.',
    imageError: 'No se pudo subir la imagen.'
  }
}
